import React, { FC, useState } from 'react';
import { UserContext } from 'common/context/user/user.context';

export interface IComponentProps {
  children: React.ReactNode;
}

export const UserProvider: FC<IComponentProps> = ({ children }) => {
  const [openUserCard, setOpenUserCard] = useState<boolean>(false);
  const [openEditUserCard, setOpenEditUserCard] = useState<boolean>(false);

  return (
    <UserContext.Provider
      value={{
        openUserCard,
        setOpenUserCard,
        openEditUserCard,
        setOpenEditUserCard,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
